import { render, staticRenderFns } from "./CriteriaItemsList.vue?vue&type=template&id=9cc43926&scoped=true"
import script from "./CriteriaItemsList.vue?vue&type=script&lang=ts"
export * from "./CriteriaItemsList.vue?vue&type=script&lang=ts"
import style0 from "./CriteriaItemsList.vue?vue&type=style&index=0&id=9cc43926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc43926",
  null
  
)

export default component.exports